"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _layoutTwoColumnsSidebarLeft = _interopRequireDefault(require("@atlaskit/icon/core/layout-two-columns-sidebar-left"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorLayoutTwoLeftSidebarIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m5 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
}, props, {
  newIcon: _layoutTwoColumnsSidebarLeft.default
}));
EditorLayoutTwoLeftSidebarIcon.displayName = 'EditorLayoutTwoLeftSidebarIcon';
var _default = exports.default = EditorLayoutTwoLeftSidebarIcon;